export class GlobalConstants {
  public static BUSINESS_PARTNER: string = "BusinessPartner";
  public static SYSTEM_ADMIN: string = "SystemAdmin";

  // Static text of Html text bindings.

  // 1. People > All Employees component
  public static APPLY_ALL_EMPLOYEES: string = "Apply";
  public static NO_RECORDS_FOUND_ALL_EMPLOYEES: string = "No records found";
  public static DETAIL_INFORMATION_ALL_EMPLOYEES: string = "Detail Information";

  public static NO_DETAILS_AVAILABLE_EMPLOYEE_DETAILS: string =
    "No details available";
  public static SEL_ANY_RECORD_TO_VIEW_DETAILS_EMPLOYEE_DETAILS: string =
    "Select any record to view in details.";
  public static UPDATE_DETAILS_EMPLOYEE_DETAILS: string = "Update Details";
  public static REQUEST_EMPLOYEE_DETAILS: string = "Request";
  public static DEPARTMENT_EMPLOYEE_DETAILS: string = "Department";
  public static MANAGER_EMPLOYEE_DETAILS: string = "Manager";
  public static TITLE_EMPLOYEE_DETAILS: string = "Title";
  public static NEW_SYS_REQUEST_EMPLOYEE_DETAILS: string =
    "System Access Actions";

  // 2 Requests > drafts.components

  public static NO_RECORDS_FOUND_DRAFTS: string = "No records found";
  public static DETAIL_INFORMATION_DRAFTS: string = "Detail Information";

  // 3 Requests > drafts-details.components
  public static NO_DETAILS_AVAILABLE_DRAFT_DETAILS: string =
    "No details available";
  public static SEL_ANY_RECORD_TO_VIEW_DETAILS_DRAFT_DETAILS: string =
    "Select any record to view in details.";
  public static UPDATE_DETAILS_DRAFT_DETAILS: string = "Update Request";
  public static APPROVE_BTN_DRAFT_DETAILS: string = "Approve Request";
  public static REJECT_BTN_DRAFT_DETAILS: string = "Reject Request";
  public static RETURN_BTN_DRAFT_DETAILS: string = "Return Request";

  // 4 Requests > New-request.components
  public static HOME_NEW_REQUEST: string = "Home";
  public static NAME_REQUEST: string = "Name:";
  public static JOB_TITLE_REQUEST: string = "Job Title:";
  public static NEW_REQ_NEW_REQUEST: string = "New Request";
  public static UPDATE_NEW_REQUEST: string = "Update";

  public static _01_NEW_REQUEST: string = "01";
  public static PERSONAL_INFO_NEW_REQUEST: string = "Personal Information";
  public static _02_NEW_REQUEST: string = "02";
  public static CONTACT_INFO_NEW_REQUEST: string = "Contact Information";
  public static _03_NEW_REQUEST: string = "03";
  public static JOB_INFO_NEW_REQUEST: string = "Job Information";
  public static _04_NEW_REQUEST: string = "04";
  public static SYSTEM_ACCESS_NEW_REQUEST: string = "System Access";

  public static PLS_ENTER_REQ_FIELD_NEW_REQUEST: string =
    "Please enter required field information and proceed to the next step";
  public static INDICATE_REQ_FIELD_NEW_REQUEST: string =
    "Indicates required field";
  public static FIRST_NAME_NEW_REQUEST: string = "First Name";
  public static MIDDLE_NAME_NEW_REQUEST: string = "Middle Name";
  public static LAST_NAME_NEW_REQUEST: string = "Last Name";
  public static PREFERRED_FIRST_NAME_NEW_REQUEST: string =
    "Preferred First Name";
  public static DATE_OF_BIRTH_NEW_REQUEST: string = "Date of birth";
  public static PLS_ENTER_REQ_FIELD1_NEW_REQUEST: string =
    "Please enter required field information and proceed to the next step";
  public static INDICATE_REQ_FIELD1_NEW_REQUEST: string =
    "Indicates required field";
  public static PERSONAL_PHONE_NEW_REQUEST: string = "Personal Phone";
  public static PERSONAL_EMAIL_NEW_REQUEST: string = "Personal Email";
  public static PERSONAL_ADDRESS_NEW_REQUEST: string = "Personal Address";
  public static APARTMENT_NEW_REQUEST: string = "Apartment / Suit";
  public static CITY_NEW_REQUEST: string = "City";
  public static STATE_NEW_REQUEST: string = "State";
  public static ZIP_CODE_NEW_REQUEST: string = "Zip code";
  public static COUNTRY_NEW_REQUEST: string = "Country";

  public static PLS_ENTER_REQ_FIELD2_NEW_REQUEST: string =
    "Please enter required field information and proceed to the next step";
  public static INDICATE_REQ_FIELD2_NEW_REQUEST: string =
    "Indicates required field";
  public static IS_THIS_PAID_POSITION_NEW_REQUEST: string =
    "Is this a Paid Position?";
  public static YES_NEW_REQUEST: string = "Yes";
  public static NO_NEW_REQUEST: string = "No";
  public static SCHEDULE_TYPE_NEW_REQUEST: string = "Schedule Type";
  public static FULL_TIME_NEW_REQUEST: string = "Full Time";
  public static PART_TIME_NEW_REQUEST: string = "Part Time";
  public static POSITION_TYPE_NEW_REQUEST: string = "Position Type";
  public static JOB_TITLE_NEW_REQUEST: string = "Job Title";
  public static AREA_NEW_REQUEST: string = "Area";
  public static DEPARTMENT_NEW_REQUEST: string = "Department";
  public static PROGRAM_NEW_REQUEST: string = "Program";
  public static SUPERVISOR_NEW_REQUEST: string = "Supervisor";
  public static LOCATION_NEW_REQUEST: string = "Location";
  public static START_DATE_NEW_REQUEST: string = "Start Date";
  public static SYSTEM_ACCESS_REVOKE_DATE_NEW_REQUEST: string =
    "System Access Revoke Date";
  public static NOTES_NEW_REQUEST: string = "Notes";

  public static INDICATES_REQ_FIELD3_NEW_REQUEST: string =
    "Indicates required field";
  public static SYSTEM_NEED_ACCESS_NEW_REQUEST: string =
    "System need access for?";
  public static PLS_JUSTIFY_EMPL_NEED_FOR_SYS_ACCESS_NEW_REQUEST: string =
    "Please justify why this Employee needs System Access?";
  public static SAVE_AS_DRAFT_NEW_REQUEST: string = "Save as draft";
  public static CLEAR_NEW_REQUEST: string = "Clear";
  public static NEXT_NEW_REQUEST: string = "Next";
  public static SUBMIT_NEW_REQUEST: string = "Submit";

  // 5 Staffing > my-department.component

  public static NO_RECORD_FOUND_MY_DEPARTMENT: string = "No records found";
  public static DETAIL_INFORMATION_MY_DEPARTMENT: string = "Detail Information";

  // 6 Staffing > my-staff.component

  public static NO_RECORD_FOUND_MY_STAFF: string = "No records found";
  public static DETAIL_INFORMATION_MY_STAFF: string = "Detail Information";

  // 7 Staffing > staff-details.component

  public static NO_DETAILS_AVAILABLE_STAFF_DETAILS: string =
    "No details available";
  public static SEL_ANY_REC_TO_VIEW_DET_STAFF_DETAILS: string =
    "Select any record to view in details.";
  public static UPDATE_DETAILS_STAFF_DETAILS: string = "Update Details";
  public static REQUEST_STAFF_DETAILS: string = "Request";
  public static DEPARTMENT_STAFF_DETAILS: string = "Department";
  public static MANAGER_STAFF_DETAILS: string = "Manager";
  public static TITLE_STAFF_DETAILS: string = "Title";
  public static NEW_SYS_REQUEST_STAFF_DETAILS: string = "System Access Actions";

  // 8 Shared > components > New System Access component.

  public static NEW_SYS_ACCESS_NEW_SYS_ACCESS: string = "New System Access";
  public static VIEW_HISTORY_NEW_SYS_ACCESS: string = "View History";
  public static NEED_ACCESS_FOR_NEW_SYS_ACCESS: string = "Need access for?";
  public static MY_SELF_NEW_SYS_ACCESS: string = "Myself";
  public static MY_STAFF_NEW_SYS_ACCESS: string = "My Staff";
  public static MY_DEPARTMENT_NEW_SYS_ACCESS: string = "My Department";
  public static STAFF_NAME_NEW_SYS_ACCESS: string = "Staff Name";
  public static SEARCH_NEW_SYS_ACCESS: string = "Search";
  public static INDICATE_REQ_FIELD_NEW_SYS_ACCESS: string =
    "Indicates required field";
  public static SYS_NEED_ACCESS_FOR_NEW_SYS_ACCESS: string =
    "System need access for?";
  public static PLS_JUST_WHY_NEED_ACCESS_NEW_SYS_ACCESS: string =
    "Please justify why this Employee needs System Access?";
  public static _500_CHARACTER_LEFT_NEW_SYS_ACCESS: string =
    "500 Character left";
  public static CLEAR_NEW_SYS_ACCESS: string = "Clear";
  public static CANCEL_SYS_ACCESS: string = "Cancel";
  public static CONFIRM_SYS_ACCESS: string = "Confirm";
  public static SUBMIT_NEW_SYS_ACCESS: string = "Submit";

  // 9 Shared > components > Revoke System Access component.

  public static REVOKE_SYS_ACCESS_REVOKE_SYS_ACCESS: string =
    "Revoke System Access";
  public static VIEW_HISTORY_REVOKE_SYS_ACCESS: string = "View History";
  public static REVOKING_ACCESS_FOR_REVOKE_SYS_ACCESS: string =
    "Revoking access for?";
  public static MY_SELF_REVOKE_SYS_ACCESS: string = "Myself";
  public static MY_STAFF_REVOKE_SYS_ACCESS: string = "My Staff";
  public static MY_DEPARTMENT_REVOKE_SYS_ACCESS: string = "My Department";
  public static STAFF_NAME_REVOKE_SYS_ACCESS: string = "Staff Name";
  public static SEARCH_REVOKE_SYS_ACCESS: string = "Search";
  public static INDICATE_REQ_FIELD_REVOKE_SYS_ACCESS: string =
    "Indicates required field";
  public static SYS_NEED_ACCESS_FOR_REVOKE_SYS_ACCESS: string =
    "System revoke access for?";
  public static PLS_JUST_WHY_NOT_NEED_ACCESS_REVOKE_SYS_ACCESS: string =
    "Please justify why this Employee doesn't need System Access?";
  public static _500_CHARACTER_LEFT_REVOKE_SYS_ACCESS: string =
    "500 Character left";
  public static CLEAR_REVOKE_SYS_ACCESS: string = "Clear";
  public static REVOKE_REVOKE_SYS_ACCESS: string = "Revoke";
  public static SUSPEND_REVOKE_SYS_ACCESS: string = "Suspend";

  // 10 sidebar navigation component.

  public static REQUEST_SIDEBAR: string = "Requests";
  public static PENDING_APPROVALS_SIDEBAR: string = "Pending Approvals";
  public static DRAFTS_SIDEBAR: string = "Drafts";
  public static PROCESSED_SIDEBAR: string = "Processed";
  public static RETURNED_SIDEBAR: string = "Returned";
  public static SUBMITTED_SIDEBAR: string = "Submitted";
  public static PENDING_STATUS: string = "Pending";
  public static PENDING_APPR_SEARCH_TYPE: string = "pendingApproval";

  public static STAFFING_SIDEBAR: string = "Staffing";
  public static MY_STAFF_SIDEBAR: string = "My Staff";
  public static MY_DEPARTMENT_SIDEBAR: string = "My Department";

  public static PEOPLE_SIDEBAR_NAV: string = "People";
  public static ALL_EMPLOYEE_SIDEBAR_NAV: string = "All Employees";
  public static NON_EMPLOYEE_SIDEBAR_NAV: string = "Non-Employees";
  public static ON_BOARDING_SIDEBAR_NAV: string = "Access Onboarding";

  // 11 details-card-component

  public static NO_DETAILS_AVAILABLE_DETAILS: string = "No details available";
  public static SELECT_ANY_RECORD_TO_VIEW_DETAILS: string =
    "Select any record to view in details.";

  // 12 Top Header Navigation-component

  public static VIEW_PROFILE_TOP_HEADER_NAV_COMP: string = "View Profile";
  public static LOG_OUT_TOP_HEADER_NAV_COMP: string = "Logout";
  //  public static actionTopheaderNavComp:string ='Action'
  //  public static anotherActionTopheaderNavComp:string ='Another action'
  //  public static somethingElsehereTopheaderNavComp:string ='Something else here'

  // 12 shared > components > Ui components > search component
  public static CREATE_REQUEST_SEARCH: string = "+ Create Request";
  public static NON_EMPLOYEE_REQUEST_SEARCH: string = "Non-Employee Request";
  public static NEW_SYSTEM_ACCESS_SEARCH: string = "New System Access";
  public static REVOKE_SYSTEM_ACCESS_SEARCH: string = "Revoke System Access";
  public static UPDATE_DETAILS_SYSTEM_ACCESS_SEARCH: string = "Update Details";

  // 13 Shared > UI components > Table
  public static NO_RECORD_FOUND_TABLE: string = "No records found.";

  // 14 Shared > components > update-detail-modal
  public static UPDATE_DETAILS_UPDATE_DET_MODAL: string = "Update Details";
  public static NAME_UPDATE_DET_MODAL: string = "Name";
  public static SEARCH_UPDATE_DET_MODAL: string = "Search";
  public static INDICATES_REQ_FIELD_UPDATE_DET_MODAL: string =
    "Indicates required field";
  public static WHAT_U_WANT_TO_CHANGE_UPDATE_DET_MODAL: string =
    "What you want to change?";
  public static PERSONAL_INFO_UPDATE_DET_MODAL: string = "Personal Information";

  public static JOB_INFO_UPDATE_DET_MODAL: string = "Job Information";
  public static DEPARTMENT_UPDATE_DET_MODAL: string = "Program";
  public static MANAGER_UPDATE_DET_MODAL: string = "Manager";
  public static LAST_NAME_UPDATE_DET_MODAL: string = "Last Name";
  public static DOCUMENT_UPDATE_DET_MODAL: string = "Document";
  public static PRIMARY_EMAIL_UPDATE_DET_MODAL: string = "Primary Email";
  public static PRIMARY_PHONE_UPDATE_DET_MODAL: string = "Primary Phone";
  public static PRIMARY_ADDRESS_UPDATE_DET_MODAL: string = "Primary Address";
  public static APARTMENT_SUIT_UPDATE_DET_MODAL: string = "Apartment/Suit";
  public static CITY_UPDATE_DET_MODAL: string = "City";
  public static STATE_UPDATE_DET_MODAL: string = "State";
  public static ZIP_CODE_UPDATE_DET_MODAL: string = "Zip Code";
  public static COUNTRY_UPDATE_DET_MODAL: string = "Country";
  public static JOB_TITLE_UPDATE_DET_MODAL: string = "Job Title";
  public static START_DATE_UPDATE_DET_MODAL: string = "Start Date";
  public static SUSPENSION_DATE_UPDATE_DET_MODAL: string = "Suspension Date";
  public static REVOCATION_DATE_UPDATE_DET_MODAL: string = "Revocation Date";
  public static TERMINATION_DATE_UPDATE_DET_MODAL: string = "Termination Date";
  public static DEPARTMENT_DATE_UPDATE_DET_MODAL: string = "Program Name";
  public static MANAGER_NAME_UPDATE_DET_MODAL: string = "New Manager Name";
  public static CURRENT_MANAGER_NAME_UPDATE_DET_MODAL: string =
    "Current Manager Name";
  public static START_DATE1_UPDATE_DET_MODAL: string = "Start Date";
  public static CLEAR_UPDATE_DET_MODAL: string = "Clear";
  public static UPDATE_UPDATE_DET_MODAL: string = "Update";
  public static SEND_FOR_APPROVAL_UPDATE_DET_MODAL: string =
    "Send for approval";

  // 15 Shared > components > view Histry -modal
  public static SYSTEM_REQUEST_VIEW_HISTORY_MODAL: string = "System Request >";
  public static VIEW_HISTORY_VIEW_HISTORY_MODAL: string = "View History";
  public static UPDATE_VIEW_HISTORY_MODAL: string = "Blank";
  public static MYSELF_VIEW_HISTORY_MODAL: string = "Myself";
  public static MY_STAFF_VIEW_HISTORY_MODAL: string = "My Staff";
  public static MY_DEPARTMENT_VIEW_HISTORY_MODAL: string = "My Department";
  public static STAFF_NAME_VIEW_HISTORY_MODAL: string = "Staff Name";
  public static SEARCH_VIEW_HISTORY_MODAL: string = "Search";
  public static OK_VIEW_HISTORY_MODAL: string = "Ok";

  // Shared > components > request approval modal
  public static APPROVAL_HEADER: string = "Approve Request";
  public static REJECT_HEADER: string = "Reject Request";
  public static RETURN_HEADER: string = "Return Request";
  public static REVOKE_HEADER: string = "Revoke Request";
  public static SUSPEND_HEADER: string = "Suspend Request";
  public static RESUME_HEADER: string = "Resume Request";
  public static ACTION_HEADER: string = "Take an action";
  public static CONFIRM_HEADER: string = "Confirm";
  public static CONFIRM_LABEL: string =
    "Are you sure you want to proceed with ";
  public static SUSPEND_CONFIRM_LABEL: string = "Suspension Request ?";
  public static REVOKE_CONFIRM_LABEL: string = "Revocation Request ?";
  public static APPROVAL_LABEL: string =
    "Are you sure you want to approve this request?";
  public static SUSPEND_CONFIRM_UPDATE_HEADER: string = `Are you sure you want to suspend user access to all agency systems and accounts?`;
  public static REVOKE_CONFIRM_UPDATE_HEADER: string = `Are you sure you want to permanently revoke user access to all agency systems and accounts?`;
  public static TERMINATION_CONFIRM_UPDATE_HEADER: string = `Are you sure you want to permanently terminate user access to all agency systems and accounts?`;
  public static SUSPEND_CONFIRM_UPDATE_DET: string = `By doing this, the user will lose access to all company applications and data.This means all access to the information and systems that are available to them will be lost if you proceed with this action.This includes platform, mail, etc. Do you want to proceed with access suspension ?`;
  public static REVOKE_CONFIRM_UPDATE_DET: string = `By doing this, the user will lose access to all company applications and data.This means all access to the information and systems that are available to them will be lost if you proceed with this action.This includes platform, mail, etc. Do you want to proceed with system revocation ?`;
  public static TERMINATION_CONFIRM_UPDATE_DET: string = `By doing this, the user will lose access to all company applications and data.This means all access to the information and systems that are available to them will be lost if you proceed with this action.This includes platform, mail, etc. Do you want to proceed with access termination ?`;
  public static ACTION_LABEL: string = "Which action do you want to take ?";
  public static REJECT_LABEL: string = "Reason for reject request";
  public static RETURN_LABEL: string = "Reason for return request";
  public static REVOKE_LABEL: string = "Reason for revoke request";
  public static SUSPEND_LABEL: string = "Reason for suspend request";
  public static RESUME_LABEL: string = "Reason for resume request";
  public static APPROVE_BTN_LABEL: string = "Approve";
  public static SUBMIT_BTN_LABEL: string = "Submit";
  public static REVOKE_ACCESS_BTN_LABEL: string = "Revoke Access";
  public static SUSPEND_ACCESS_BTN_LABEL: string = "Suspend Access";
  public static RESUME_ACCESS_BTN_LABEL: string = "Resume Access";
  public static ONBOARD_CONFIRM_MSG: string = "Entity ID already generated for the employee : ";
  public static ONBOARD_PROCEED_MSG: string = "Do you still want to proceed ?";
  public static ONBOARD_PROCEED_LABEL: string = "Proceed";

  // Workflow request status
  public static WORKFLOW_REQUEST_CREATED: number = 1001;
  public static WORKFLOW_SUPERVISOR_RETURNED: number = 1002;
  public static WORKFLOW_SUPERVISOR_APPROVED: number = 1003;
  public static WORKFLOW_SUPERVISOR_REJECTED: number = 1004;
  public static WORKFLOW_HR_APPROVED: number = 1005;
  public static WORKFLOW_HR_REJECTED: number = 1006;
  public static WORKFLOW_SYSTEM_ADMIN_APPROVED: number = 1007;
  public static WORKFLOW_SYSTEM_ADMIN_REJECTED: number = 1008;
  public static WORKFLOW_REQUEST_RESUBMITTED: number = 1009;
  public static WORKFLOW_REQUEST_APPROVED: number = 1010;
  public static WORKFLOW_HR_RETURNED: number = 1011;
  public static WORKFLOW_AD_SYNCED: number = 1012;
  public static WORKFLOW_IT_ADMIN_APPROVED: number = 1013;
  public static WORKFLOW_NEW_SYSTEM_ACCESS_REQUEST: number = 5001;
  public static WORKFLOW_REVOKE_SYSTEM_ACCESS_REQUEST: number = 5002;
  public static WORKFLOW_SUSPEND_SYSTEM_ACCESS_REQUEST: number = 5003;

  // Role information
  public static ROLE_HR: string = "BusinessPartner";
  public static ROLE_SUPERVISOR: string = "Employee";
  public static ROLE_APP_ADMIN: string = "AppAdmin";
  public static ROLE_NON_EMPLOYEE: string = "NonEmployee";
  public static ROLE_IT_ADMIN: string = "ITAdmin";

  // Status Color information
  public static ACTIVE_STATUS: string = "active";
  public static REJECT_STATUS: string = "reject";
  public static RETURN_STATUS: string = "return";

  // Update detail Popup information
  public static REQUEST_TYPE: string = "Type Of Request";
  public static STAFF_NAME: string = "Staff Name";

  // Request tab filter information
  public static DATE_FROM: string = "From";
  public static DATE_TO: string = "To";

  // Button details
  public static SUSPEND_BUTTON_LABEL: string = "Suspend";
  public static REVOKE_BUTTON_LABEL: string = "Revoke";
  public static TERMINATE_BUTTON_LABEL: string = "Terminate";
  public static PERSON_DETAILS_HEADER: string = "Person Details";

  // On Boarding
  public static ON_BOARDING_MODAL_HEADER_LABEL: string = "Onboarding Employee";
  public static ON_BOARDING_MODAL_HEADER_CREATED: string =
    "Previously created entity names";
  public static ON_BOARDING_MODAL_HEADER_ALLOCATED: string =
    "Recently allocated entity names";
  public static ON_BOARDING_MODAL_HEADER_SIMILAR_ALLOCATED: string =
    "Similarly allocated entity names";
  public static HIRING_DATE: string = "Hiring Date";
  public static FETCH_AVAILABLE_ID: string = "Generate ID";
  public static DOMAIN_ID: string = "@bakerripley.org";

  public static DETAILS: string = "Details";
  public static HISTORY: string = "History";
  public static SYSTEM_ACCESS: string = "System Access";
  public static DETAILS_CONTENT: string = "details";
  public static HISTORY_CONTENT: string = "history";
  public static SYSTEM_ACCESS_CONTENT: string = "systemAccess";
  public static PEOPLE: string = "people";
  public static TYPE_PEOPLE: string = "People";
  public static TYPE_EMPLOYEE: string = "employee";
  public static TYPE_UPDATE: string = "update";
  public static AREA_LABEL: string = "Area";
  public static DEPARTMENT_LABEL: string = "Department";
  public static LOCATION_LABEL: string = "Location";
  public static PROGRAM_LABEL: string = "Program";
  public static ALL_LABEL: string = "all";
  public static CLOSE_LABEL: string = "close";
  public static CLEAR_LABEL: string = "clear";
  public static APPLY_LABEL: string = "apply";

  public static PERSONAL_INFORMATION: string = "Personal Information";
  public static FIRST_NAME: string = "First Name";
  public static LAST_NAME: string = "Last Name";
  public static MIDDLE_NAME: string = "Middle Name";
  public static P_FIRSTNAME: string = "Preferred First Name";
  public static DATE_OF_BIRTH: string = "Date of Birth";
  public static CONTACT_INFORMATION: string = "Contact Information";
  public static P_EMAIL: string = "Primary Email";
  public static P_PHONE: string = "Primary Phone";
  public static P_ADDRESS: string = "Primary Address";
  public static APARTMENT_SUIT: string = "Apartment/Suit";
  public static CITY: string = "City";
  public static STATE: string = "State";
  public static ZIPCODE: string = "Zip Code";
  public static COUNTRY: string = "Country";
  public static JOB_INFORMATION: string = "Job Information";
  public static EMPLOYEE_ID: string = "Employee ID";
  public static EMP_TYPE: string = "Full/Part Time";
  public static FULL_TIME_TYPE: string = "Full Time";
  public static PART_TIME_TYPE: string = "Part Time";
  public static EMP_STATUS: string = "Employment Status";
  public static SUPERVISOR: string = "Supervisor";
  public static JOB_TITLE: string = "Job Title";
  public static START_DATE: string = "Start Date";
  public static END_DATE: string = "End Date";
  public static WORK_EMAIL: string = "Work Email";
  public static DEPARTMENT_INFORMATION: string = "Department Information";
  public static PROGRAM_NAME: string = "Program Name";
  public static DEPARTMENT_NAME: string = "Department Name";
  public static SYS_ACC_REVOKE_DATE: string = "System Access Revoke Date";
  public static NOTES: string = "Notes";
  public static PAID_POSITION: string = "Is this a Paid Position?";
  public static POSITION_TYPE: string = "Position Type";
  public static REQ_COUNTRY: string = "United States";

  public static TRUE_FLAG: string = "true";
  public static FALSE_FLAG: string = "false";

  public static NON_EMPLOYEE: string = "Non Employee";
  public static REVOKE_SYSTEM: string = "Revoke System";
  public static SUSPEND_SYSTEM: string = "Suspend System";
  public static PROGRAM_UPDATE: string = "Program Update";
  public static MANAGER_UPDATE: string = "Manager Update";
  public static JOB_TITLE_UPDATE: string = "Job Title Update";
  public static ACCESS_END_REQUEST: string = "Access End Request";
  public static CONTACT_UPDATE: string = "Contact Info Update";
  public static REQ_SUBMITTED: string = "Request Submitted";
  public static SUPERVISOR_REVIEW: string = "Supervisor review";
  public static SUPERVISOR_REVIEW_LABEL: string = "Supervisor Review";
  public static HR_REVIEW_LABEL: string = "HR Review";
  public static HR_REVIEW: string = "HR review";
  public static IT_ADMIN_APPROVED: string = "ITAdmin Approved";
  public static ADMIN_REVIEW: string = "Admin Review";
  public static REQ_APPROVED: string = "Request Approved";
  public static SUBMITTED_STATUS: string = "Submitted";
  public static WORKFLOW: string = "WorkFlow";
  public static TRACKING: string = "Tracking";
  public static NEW_REQUEST: string = "New Request";
  public static REQ_APPROVAL: string = "Request approval";
  public static SYSTEM_ADMIN_REVIEW: string = "SystemAdmin review";

  public static APPROVED: string = "Approved";
  public static COMPLETED: string = "Completed";
  public static REJECTED: string = "Rejected";
  public static RETURNED: string = "Returned";
  public static SUBMITTED: string = "Submitted";

  public static ACTION_APPROVED: string = "approve";
  public static ACTION_REJECTED: string = "reject";
  public static ACTION_RETURNED: string = "return";

  public static NE_REQ_APPR_MSG: string =
    "Non-Employee request has been approved successfully.";
  public static NE_REQ_REJ_MSG: string =
    "Non-Employee request has been rejected.";
  public static NE_REQ_APPR_SUP_MSG: string =
    "Non-Employee request has been approved by Supervisor.";
  public static NE_REQ_APPR_SUP_SUB_MSG: string =
    "Next level of approval will be sent to the Business Partner";
  public static NE_REQ_APPR_SUP_SUB_SUB_MSG: string =
    "Please wait until it gets approved.";
  public static NE_REQ_RET_MSG: string =
    "Non-Employee request has been returned.";
  public static NE_REQ_RET_SUB_MSG: string =
    "The Non-Employee request is sent back to Requester.";
  public static NE_REQ_RET_SUB_SUB_MSG: string =
    "Please wait until it gets resubmitted.";
  public static NE_REQ_ERR_MSG: string =
    "Error occurred in non employee request process workflow.";
  public static SA_REQ_APPR_SUP_MSG: string =
    " request has been approved by Supervisor.";
  public static SA_REQ_APPR_COM_MSG: string =
    " request has been approved successfully.";
  public static SA_REQ_APPR_SUP_SUB_MSG: string =
    "Next level of approval will be sent to the System Admin";
  public static SA_REQ_APPR_SUP_SUB_SUB_MSG: string =
    "Please wait until it gets approved";
  public static SA_REQ_REJ_MSG: string = " request has been rejected.";
  public static SA_REQ_RET_MSG: string =
    " request has been returned for modification.";
  public static SA_REQ_ERR_MSG_START: string = "Error occurred in submitting ";
  public static SA_REQ_ERR_MSG_END: string = " request workflow.";
  public static PU_REQ_APPR_MSG: string =
    "Program update request has been approved by HR.";
  public static PU_REQ_APPR_ERR_MSG: string =
    "Error occurred in approving program update request.";
  public static PU_REQ_REJ_MSG: string =
    "Program update request has been rejected by HR.";
  public static PU_REQ_REJ_ERR_MSG: string =
    "Error occurred in rejecting program update request.";
  public static MU_REQ_APPR_MSG: string =
    "Manager update request has been approved by HR.";
  public static MU_REQ_APPR_ERR_MSG: string =
    "Error occurred in approving manager update request.";
  public static MU_REQ_REJ_MSG: string =
    "Manager update request has been rejected by HR.";
  public static MU_REQ_REJ_ERR_MSG: string =
    "Error occurred in rejecting manager update request.";
  public static JTU_REQ_APPR_MSG: string =
    "Job title update request has been approved by HR.";
  public static JTU_REQ_APPR_ERR_MSG: string =
    "Error occurred in approving job title update request.";
  public static JTU_REQ_REJ_MSG: string =
    "Job title update request has been rejected by HR.";
  public static JTU_REQ_REJ_ERR_MSG: string =
    "Error occurred in rejecting job title update request.";
  public static AE_REQ_APPR_MSG: string =
    "Access end request has been approved by HR.";
  public static AE_REQ_APPR_ERR_MSG: string =
    "Error occurred in approving access end request.";
  public static AE_REQ_REJ_MSG: string =
    "Access end request has been rejected by HR.";
  public static AE_REQ_REJ_ERR_MSG: string =
    "Error occurred in rejecting access end request.";
  public static CI_REQ_APPR_MSG: string =
    "Contact information update request has been approved by HR.";
  public static CI_REQ_APPR_ERR_MSG: string =
    "Error occurred in approving Contact information update request.";
  public static CI_REQ_REJ_MSG: string =
    "Contact information update request has been rejected by HR.";
  public static CI_REQ_REJ_ERR_MSG: string =
    "Error occurred in rejecting Contact information update request.";
  public static NE_REQ_SUBMT_MSG: string =
    "Non-Employee request has been successfully submitted.";
  public static NE_REQ_SUBMT_SUB_MSG: string =
    "The request for approval is sent to Supervisor.";
  public static NE_REQ_SUBMT_SUB_SUB_MSG: string =
    "Please wait until it gets approved";
  public static NE_REQ_SUBMT_ERR_MSG: string =
    "Error occurred in submitting Non-Employee request.";
  public static NE_REQ_DRAFT_ERR_MSG: string =
    "Error occurred in saving draft.";
  public static NE_REQ_AUTO_APPR_ERR_MSG: string =
    "Error occurred in auto approval flow of Non-Employee request.";
  public static NE_REQ_USR_EXIST_MSG: string = "User Already exists.";
  public static DRAFT_REQ_SAVE_MSG: string =
    "Drafts details saved successfully.";
  public static START_DATE_VALIDATION_MSG: string =
    "Start Date should be lesser than system access revoke date.";
  public static ACCESS_DATE_VALIDATION_MSG: string =
    "System access revoke date should be greater than start date.";
  public static INVALID_DATE_MSG: string = "Invalid Date";
  public static AGE_VALIDATION_MSG: string =
    "Age should be greater than or equal to 18 years.";
  public static PROGRAM_VALIDATION_MSG: string =
    "Please select program to choose supervisor";
  public static DEPT_VALIDATION_MSG: string =
    "Please select department to choose program";
  public static AREA_VALIDATION_MSG: string =
    "Please select area to choose department";
  public static SYSTEM_ACCESS_APPR_MSG: string =
    "System Access request has been successfully submitted.";
  public static SYSTEM_ACCESS_SUPR_APPR_MSG: string =
    "The request for approval is send to Supervisor";
  public static SYSTEM_ACCESS_SUPR_SUB_MSG: string =
    "Please wait until it gets approved";
  public static SYSTEM_NEW_ACCESS_ERR_MSG: string =
    "Error occurred in submitting new system access request.";
  public static SYSTEM_SUS_ACCESS_SUBMT_MSG: string =
    "Suspend System Access request has been successfully submitted.";
  public static SYSTEM_REV_ACCESS_SUBMT_MSG: string =
    "Revoke System Access request has been successfully submitted.";
  public static SYSTEM_SUS_ACCESS_ERR_MSG: string =
    "Error occurred in submitting suspend system access request";
  public static SYSTEM_REV_ACCESS_ERR_MSG: string =
    "Error occurred in submitting revoke system access request";
  public static SYSTEM_RES_ACCESS_SUBMT_MSG: string =
    "Resume System Access request has been successfully submitted.";
  public static SYSTEM_RES_ACCESS_ERR_MSG: string =
    "Error occurred in submitting resume system access request";

  public static YES: string = "yes";
  public static NO: string = "no";
  public static FULL_TIME: string = "fullTime";
  public static PART_TIME: string = "partTime";
  public static PERSONAL_INFO_TAB: string = "personalInformation";
  public static CONTACT_INFO_TAB: string = "contactInformation";
  public static JOB_INFO_TAB: string = "jobInformation";
  public static SYSTEM_ACCESS_TAB: string = "systemAccessForm";
  public static USER_ROLE_KEY: string = "userRole"
  public static CURRENT_USER_DET_KEY: string = "currentUserDetails"
}
